import { render } from "./ForgottenPasswordView.vue?vue&type=template&id=45077437"
import script from "./ForgottenPasswordView.vue?vue&type=script&lang=js"
export * from "./ForgottenPasswordView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/ForgottenPasswordView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "45077437"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('45077437', __exports__)) {
    api.reload('45077437', __exports__)
  }
  
  module.hot.accept("./ForgottenPasswordView.vue?vue&type=template&id=45077437", () => {
    api.rerender('45077437', render)
  })

}


export default __exports__